import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Eye } from 'react-feather'

import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const TableTransactionBank = ({ useFetchInit }) => {

    const {
        FetchData,
        Helpers,
        Actions
    } = useFetchInit

    // ------------------------------------------------ FetchData
    const { fetchBankDeposits, fetchAllBanks } = FetchData
    const { dataBankDeposits, loadingFetchBankDeposits } = fetchBankDeposits
    const { banks } = fetchAllBanks

    // ------------------------------------------------ Helpers
    const { formatMoney } = Helpers

    // ------------------------------------------------ Actions
    const { handleClickShowDeposit } = Actions

    const columnConfig = [
        {
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <>
                        <TooltipInformation
                            usuario_creo={usuario_creo}
                            fecha_creo={fecha_creo}
                            usuario_modifico={usuario_modifico}
                            fecha_modifico={fecha_modifico}
                        />
                    </>
                )
            }
        },
        {
            field: 'idbanco',
            headerName: 'BANCO',
            minWidth: 160,
            filter: true,
            valueFormatter: (params) => {
                const banco = banks.find(b => b.idbanco === params.value)
                return banco ? banco.nombre : params.value
            }
        },
        {
            field: 'idcredito',
            headerName: 'CREDITO',
            minWidth: 115,
            filter: true,
            valueFormatter: (params) => params.value == null ? '--' : params.value
        },
        { field: 'origen', headerName: 'ORIGEN', minWidth: 240, filter: true },
        { field: 'fecha', headerName: 'FECHA', minWidth: 120, filter: true },
        {
            field: 'monto',
            headerName: 'MONTO',
            minWidth: 120,
            filter: true,
            valueFormatter: (params) => {
                const moneda = params.data?.moneda
                const formatted = formatMoney(params.value)
                return moneda === 'DOLAR' ? `$ ${formatted}` : `Q. ${formatted}`
            }
        },
        { field: 'moneda', headerName: 'MONEDA', minWidth: 110, filter: true },
        { field: 'tipo_cambio', headerName: 'T/C', minWidth: 100, filter: true },
        {
            field: 'quetzales',
            headerName: 'QUETZALES',
            minWidth: 140,
            filter: true,
            valueFormatter: (params) => `Q. ${formatMoney(params.value)}`
        },
        {
            field: 'dolares',
            headerName: 'DOLARES',
            minWidth: 130,
            filter: true,
            valueFormatter: (params) => `$ ${formatMoney(params.value)}`
        },
        { field: 'boleta_numero', headerName: 'BOLETA #', minWidth: 150, filter: true },
        { field: 'aprobacion_check', headerName: 'APROBACION', minWidth: 140, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 200,
            cellRenderer: (params) => {
                const rowData = params.data
                return (
                    <CustomDropDown>
                        <MenuItem onClick={() => handleClickShowDeposit(rowData)}>
                            <ListItemIcon> <Eye color="black" /> </ListItemIcon>
                            <ListItemText primary="Informacion" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {loadingFetchBankDeposits && (<LinearLoading />)}
            <CustomTableData
                rowConfig={dataBankDeposits}
                columnConfig={columnConfig}
            />
        </div>
    )
}
